import { render } from "./create-single.vue?vue&type=template&id=4a7e3c29&ts=true"
import script from "./create-single.vue?vue&type=script&lang=ts"
export * from "./create-single.vue?vue&type=script&lang=ts"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__